import { useEffect, useState } from "react";
import { ColumnsType } from "antd/es/table";
import { cellWidth } from "../../../core/methods/tableCellWidth";
import Datatable from "../../../core/common/dataTable";
import FiltersTrackCase, {
  FiltersSelectType,
  SearchFormDataType,
  SearchPayloadType,
} from "../FiltersTrackCase";
import {
  parseDate,
  parseDaysString,
  parseNumber,
} from "../../../core/methods/sorterMethods";
import TimelineModal from "../TimelineModal";
import ModifyInviteModal from "./ModifyInviteModal";
import { statusColors } from "../ApplicantInvited";
import { getSearchableHeader } from "../../utils/getSearchableHeader";
import useApi from "../../../core/customhook/useApi";
import webservice_url from "../../../core/webservice/Webservice_url";
import Loading from "../../../core/common/custom-loading/Loading";
import EditIcon from "../../../core/svg-icons/EditIcon";
import Swal from "sweetalert2";
import { exportAntdTableToExcel } from "../../utils/exportExcel";
export type TableApiPayload = {
  program_id: string[];
  department_id: string[];
  status: string[];
  assigned_user_id: string[];
  project_id: string[];
  page: number;
  limit: number;
};

const buildTableApiPayload = (
  searchPayload: Partial<SearchPayloadType>,
  page: number,
  limit: number,
  statusId?: string,
): TableApiPayload => ({
  program_id: searchPayload.program ?? [],
  department_id: searchPayload.department ?? [],
  status: statusId ? [statusId] : [],
  project_id: searchPayload.project ?? [],
  assigned_user_id: searchPayload.users ?? [],
  page,
  limit,
});
interface ApplicationSubmittedProps {
  statusId?: string;
}
const TotalInviteSent = ({ statusId }: ApplicationSubmittedProps) => {
  const [itemList, setItemList] = useState<any[]>([]);
  const [searchFilter, setSearchFilter] = useState<SearchFormDataType>({
    case_id: "",
    applicant_name: "",
    email: "",
    from_date: "",
    to_date: "",
  });

  const [filterData, setFilterData] = useState<FiltersSelectType>({
    organization: [],
    project: [],
    location: [],
    program: [],
    department: [],
    users: [],
  });
  const [lastSearchPayload, setLastSearchPayload] = useState<
    Partial<SearchPayloadType>
  >({});
  const [pagination, setPagination] = useState({ page: 1, limit: 1000 });
  const [total, setTotal] = useState(0);
  const [selectedInvite, setSelectedInvite] = useState<any>(null);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [showTimeline, setShowTimeline] = useState<boolean>(false);
  const [showModifyInvite, setShowModifyInvite] = useState<boolean>(false);
  const [inventoryColumnSearch, setInventoryColumnSearch] = useState<
    Record<string, string>
  >({});

  // VIEW LOG API CALLING
  const [timelineData, setTimelineData] = useState<any[]>([]);
  const [timelineLoading, setTimelineLoading] = useState<boolean>(false);

  const getCaseLog = useApi<any>(webservice_url.ViewLogAPI, {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });
  const resendInvitation = useApi<any>(webservice_url.sendInvitationAPI, {
    method: "PATCH",
    autoCall: false,
    handleGlobalError: false,
  });

  const handleViewLog = async (caseId?: string) => {
    if (!caseId) return;
    setShowTimeline(true);
    setTimelineLoading(true);
    try {
      const res = await getCaseLog.callApi({ case_id: caseId });
      setTimelineData(res?.data ?? []);
    } catch (err) {
      console.error(err);
      setTimelineData([]);
    } finally {
      setTimelineLoading(false);
    }
  };

  const getDaysElapsed = (invitationDate?: string) => {
    if (!invitationDate) return "-";

    const today = new Date();
    const invitedDate = new Date(invitationDate);

    // Remove time part
    today.setHours(0, 0, 0, 0);
    invitedDate.setHours(0, 0, 0, 0);

    const diffTime = today.getTime() - invitedDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    return diffDays >= 0
      ? `${diffDays} Day${diffDays !== 1 ? "s" : ""}`
      : "0 Days";
  };

  const getExpireIn = (expiryDate?: string) => {
    if (!expiryDate) return "-";

    const today = new Date();
    const expiry = new Date(expiryDate);

    // Remove time part
    today.setHours(0, 0, 0, 0);
    expiry.setHours(0, 0, 0, 0);

    const diffTime = expiry.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return "Expired";

    return `${diffDays} Day${diffDays !== 1 ? "s" : ""}`;
  };

  type InviteItem = any;
  const filteredData = (Array.isArray(itemList) ? itemList : []).filter(
    (item: InviteItem) => {
      return Object.entries(inventoryColumnSearch).every(([key, value]) => {
        if (!value) return true;

        return String(item[key as keyof InviteItem] ?? "")
          .toLowerCase()
          .includes(value.toLowerCase());
      });
    },
  );
  const columns: ColumnsType = [
    // {
    //   title: (
    //     <div className="d-flex align-items-center gap-2 justify-content-center">
    //       <span>Select All</span>
    //       <Checkbox
    //         checked={
    //           filteredData.length > 0 &&
    //           filteredData.every((item: any) =>
    //             selectedRows.some(
    //               (selected) =>
    //                 String(selected.assignment_id) ===
    //                 String(item.assignment_id),
    //             ),
    //           )
    //         }
    //         onChange={(e) => handleSelectAll(e.target.checked)}
    //       />
    //     </div>
    //   ),
    //   align: "center",
    //   render: (_: any, record: any) => (
    //     <Checkbox
    //       checked={isRowSelected(record)}
    //       onChange={(e) => handleRowCheckboxChange(e.target.checked, record)}
    //     />
    //   ),
    // },

    {
      title: "Sr. No.",
      key: "serial_number",
      dataIndex: "serial_number",
      width: 80,
      align: "center",
    },
    {
      title: getSearchableHeader(
        "Applicant Name",
        "candidate_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "candidate_name",
      key: "candidate_name",
      onCell: () => cellWidth(220), 
      sorter: (a: any, b: any) =>
        (a.candidate_name ?? "").localeCompare(b.candidate_name ?? ""),
    },
    {
      title: getSearchableHeader(
        "Case ID",
        "case_id",
        setInventoryColumnSearch,
      ),
      dataIndex: "case_id",
      key: "case_id",
      onCell: () => cellWidth(220),
      sorter: (a: any, b: any) =>
        parseNumber(a.case_id) - parseNumber(b.case_id),
    },
    {
      title: getSearchableHeader(
        "Case SPOC",
        "case_spoc_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "case_spoc_name",
      key: "case_spoc_name",
      onCell: () => cellWidth(220),
      sorter: (a: any, b: any) =>
        (a.case_spoc_name ?? "").localeCompare(b.case_spoc_name ?? ""),
    },
    {
      title: getSearchableHeader(
        "Case Status",
        "overall_status",
        setInventoryColumnSearch,
      ),
      dataIndex: "overall_status",
      key: "overall_status",
      onCell: () => cellWidth(220),
      sorter: (a: any, b: any) =>
        (a.overall_status ?? "").localeCompare(b.overall_status ?? ""),
      render: (text: any, record: any) => {
        return (
          <span
            style={{
              backgroundColor: record?.overall_color_value || "#F59E0B",
              color: "#fff",
              padding: "5px 10px",
              borderRadius: "4px",
              display: "inline-block",
              fontSize: "12px",
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            {text ?? "-"}
          </span>
        );
      },
    },
    {
      title: getSearchableHeader(
        "Candidate ID",
        "employee_id",
        setInventoryColumnSearch,
      ),
      dataIndex: "employee_id",
      key: "employee_id",
      onCell: () => cellWidth(220),
      sorter: (a: any, b: any) =>
        (a.employee_id ?? "").localeCompare(b.employee_id ?? ""),
    },
    {
      title: getSearchableHeader(
        "Project",
        "project_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "project_name",
      key: "project_name",
      onCell: () => cellWidth(220),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.project_name ?? "").localeCompare(b.project_name ?? ""),
    },
    {
      title: getSearchableHeader(
        "Program",
        "program_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "program_name",
      key: "program_name",
      onCell: () => cellWidth(220),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.program_name ?? "").localeCompare(b.program_name ?? ""),
    },
    {
      title: getSearchableHeader(
        "Department",
        "department_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "department_name",
      key: "department_name",
      onCell: () => cellWidth(220),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.department_name ?? "").localeCompare(b.department_name ?? ""),
    },
    {
      title: getSearchableHeader("Email ID", "email", setInventoryColumnSearch),
      dataIndex: "email",
      key: "email",
      sorter: (a: any, b: any) => (a.email ?? "").localeCompare(b.email ?? ""),
    },
    {
      title: getSearchableHeader(
        "Days Elapsed",
        "days_elapsed",
        setInventoryColumnSearch,
      ),
      dataIndex: "days_elapsed",
      key: "days_elapsed",
      onCell: () => cellWidth(220),
      render: (value: string) => value || "-",
      sorter: (a: any, b: any) =>
        parseDaysString(a.days_elapsed) - parseDaysString(b.days_elapsed),
    },
    {
      title: getSearchableHeader(
        "Phone No.",
        "phone",
        setInventoryColumnSearch,
      ),
      dataIndex: "phone",
      key: "phone",
      onCell: () => cellWidth(220),
      render: (text: any) => <div>{text || "-"}</div>,
      sorter: (a: any, b: any) => parseNumber(a.phone) - parseNumber(b.phone),
    },
    {
      title: getSearchableHeader(
        "Invitation Date",
        "invitation_date",
        setInventoryColumnSearch,
      ),
      dataIndex: "invitation_date",
      key: "invitation_date",
      onCell: () => cellWidth(220),
      sorter: (a: any, b: any) =>
        parseDate(a.invitation_date).getTime() -
        parseDate(b.invitation_date).getTime(),
    },
    // {
    //   title: "Expire In",
    //   dataIndex: "expires_at",
    //   key: "expires_at",
    //   onCell: () => cellWidth(220),
    //   render: (value: string) => {
    //     if (value === "Expired") {
    //       return <span className="badge bg-danger">Expired</span>;
    //     }

    //     return <span>{value}</span>;
    //   },
    //   sorter: (a: any, b: any) =>
    //     parseDaysString(a.expires_at) - parseDaysString(b.expires_at),
    // },
    {
      title: getSearchableHeader("PAN No", "pan_no", setInventoryColumnSearch),
      dataIndex: "pan_no",
      key: "pan_no",
      onCell: () => cellWidth(220),
      render: (value: any) => value || "-",
      sorter: (a: any, b: any) =>
        String(a.pan_no ?? "").localeCompare(String(b.pan_no ?? "")),
    },
    {
      title: getSearchableHeader("UAN No", "uan_no", setInventoryColumnSearch),
      dataIndex: "uan_no",
      key: "uan_no",
      onCell: () => cellWidth(220),
      render: (value: any) => value || "-",
      sorter: (a: any, b: any) =>
        String(a.uan_no ?? "").localeCompare(String(b.uan_no ?? "")),
    },
    {
      title: getSearchableHeader(
        "Aadhar Address",
        "address1",
        setInventoryColumnSearch,
      ),
      dataIndex: "address1",
      key: "address1",
      onCell: () => cellWidth(220),
      render: (value: any) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
          {value || "-"}
        </div>
      ),
      sorter: (a: any, b: any) =>
        String(a.address1 ?? "").localeCompare(String(b.address1 ?? "")),
    },
    {
      title: getSearchableHeader(
        "Applicant Address",
        "address2",
        setInventoryColumnSearch,
      ),
      dataIndex: "address2",
      key: "address2",
      onCell: () => cellWidth(220),
      render: (value: any) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
          {value || "-"}
        </div>
      ),
      sorter: (a: any, b: any) =>
        String(a.address2 ?? "").localeCompare(String(b.address2 ?? "")),
    },
    {
      title: getSearchableHeader(
        "Status",
        "candidate_status",
        setInventoryColumnSearch,
      ),
      dataIndex: "candidate_status",
      key: "candidate_status",
      align: "center",
      onCell: () => cellWidth(180),
      render: (status: string) => (
        <span
          className={`badge ${
            statusColors[status?.toUpperCase()] || "bg-secondary"
          }`}
        >
          {status || "-"}
        </span>
      ),
      sorter: (a: any, b: any) =>
        (a.candidate_status ?? "").localeCompare(b.candidate_status ?? ""),
    },

    {
      title: "Action",
      key: "action",
      onCell: () => cellWidth(160),
      render: (_: any, record: any) => (
        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={() => {
            setSelectedInvite(record);
            setShowModifyInvite(true);
          }}
        >
          <EditIcon />
          &nbsp;Modify Invite
        </button>
      ),
    },
    {
      title: "View Log",
      key: "viewLog",
      onCell: () => cellWidth(120),
      render: (_: any, record: any) => (
        <div
          className="text-center text-dark"
          style={{ cursor: "pointer" }}
          onClick={() => handleViewLog(record.case_id)}
        >
          <i className="ti ti-eye"></i>
        </div>
      ),
    },
  ];

  const bgvBulkVerification = useApi(webservice_url.BgvbulkVerification, {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  const getTableData = useApi<any>(webservice_url.getApplicationTableData, {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  const fetchTableData = async (
    searchPayload: Partial<SearchPayloadType>,
    page: number,
    limit: number,
  ) => {
    try {
      const apiPayload = buildTableApiPayload(
        searchPayload,
        page,
        limit,
        statusId,
      );
      const res = await getTableData.callApi(apiPayload);

      const rows: any[] = res?.data?.table ?? [];
      const paginationInfo = res?.data?.pagination;

      const mapped = rows.map((row: any, idx: number) => {
        const currentPage = paginationInfo?.page ?? page;
        const currentLimit = paginationInfo?.limit ?? limit;

        return {
          serial_number: row.serial_number,
          candidate_id:
            row.candidate_id ??
            row.org_case?.candidate_id ??
            row.candidate?.candidate_id,

          assignment_id: row.assignment_id ?? row.org_case?.assignment_id,

          candidate_name: row.candidate_name,
          case_id: row.case_id ?? row.org_case?.case_id,
          case_spoc_name: row.case_spoc_name,
          employee_id: row.hrms_id,
          email: row.email,
          phone: row.phone,
          days_elapsed: getDaysElapsed(row.assigned_at ?? row.invitation_date),
          invitation_date: row.invitation_date,
          candidate_status: row.candidate_status,
          expires_at: getExpireIn(row.expires_at ?? row.invitation_expiry_date),
          department_name: row.department_name,
          program_name: row.program_name,
          project_name: row.project_name,
          pan_no: row.pan_no,
          uan_no: row.uan_no,
          address1: row.aadhar_address,
          address2: row.applicant_address,
          overall_status: row.overall_status,
          overall_color_value: row.overall_color_value,
        };
      });

      setItemList(mapped);
      setTotal(paginationInfo?.total ?? mapped.length);
      setPagination({
        page: paginationInfo?.page ?? page,
        limit: paginationInfo?.limit ?? limit,
      });
    } catch (err) {
      console.error(err);
      setItemList([]);
      setTotal(0);
    }
  };

  // const isRowSelected = (record: any) => {
  //   return selectedRows.some(
  //     (item) => String(item.assignment_id) === String(record.assignment_id),
  //   );
  // };

  // const handleRowCheckboxChange = (checked: boolean, record: any) => {
  //   if (checked) {
  //     setSelectedRows((prev) => {
  //       const alreadySelected = prev.some(
  //         (item) => String(item.assignment_id) === String(record.assignment_id),
  //       );

  //       if (alreadySelected) {
  //         return prev;
  //       }

  //       return [...prev, record];
  //     });
  //   } else {
  //     setSelectedRows((prev) =>
  //       prev.filter(
  //         (item) => String(item.assignment_id) !== String(record.assignment_id),
  //       ),
  //     );
  //   }
  // };

  // const handleSelectAll = (checked: boolean) => {
  //   if (checked) {
  //     setSelectedRows((prev) => {
  //       const existingIds = new Set(
  //         prev.map((item) => String(item.assignment_id)),
  //       );

  //       const newRows = filteredData.filter(
  //         (item: any) => !existingIds.has(String(item.assignment_id)),
  //       );

  //       return [...prev, ...newRows];
  //     });
  //   } else {
  //     const currentPageIds = new Set(
  //       filteredData.map((item: any) => String(item.assignment_id)),
  //     );

  //     setSelectedRows((prev) =>
  //       prev.filter((item) => !currentPageIds.has(String(item.assignment_id))),
  //     );
  //   }
  // };

  useEffect(() => {
    fetchTableData({}, pagination.page, pagination.limit);
  }, []);

  const handleSearch = (payload: SearchPayloadType) => {
    setLastSearchPayload(payload);
    setPagination({ page: 1, limit: pagination.limit });
    fetchTableData(payload, 1, pagination.limit);
  };

  const handleTableChange = (
    page: number,
    limit: number = pagination.limit,
  ) => {
    if (page === pagination.page && limit === pagination.limit) {
      return;
    }
    setPagination({ page, limit });
    fetchTableData(lastSearchPayload, page, limit);
  };

  const handleDownloadExcel = () => {
    exportAntdTableToExcel({
      columns,
      dataSource: filteredData,
      fileName: "Total_Invitation_Report",
      sheetName: "Total Invitation",
    });
  };

  const handleStartPreBGV = async () => {
    if (selectedRows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Candidate Selected",
        text: "Please select at least one candidate.",
        confirmButtonColor: "#f26522",
      });

      return;
    }

    const payload = selectedRows.map((item: any) => ({
      candidate_id: String(item.candidate_id ?? ""),
      assignment_id: String(item.assignment_id ?? ""),
    }));

    const invalidRows = payload.filter(
      (item) => !item.candidate_id || !item.assignment_id,
    );

    if (invalidRows.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Invalid Selection",
        text: "Candidate ID or Assignment ID is missing for one or more selected candidates.",
        confirmButtonColor: "#f26522",
      });

      return;
    }

    try {
      Swal.fire({
        title: "Starting Pre BGV...",
        text: `Processing ${payload.length} candidate${
          payload.length > 1 ? "s" : ""
        }. Please wait.`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: true,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await bgvBulkVerification.callApi(payload);

      Swal.close();

      await Swal.fire({
        icon: "success",
        title: "Pre BGV Started",
        text:
          response?.message ||
          `Pre BGV has been started for ${payload.length} candidate${
            payload.length > 1 ? "s" : ""
          }.`,
        confirmButtonColor: "#f26522",
        confirmButtonText: "OK",
      });

      // Clear selection after successful API call
      setSelectedRows([]);

      // Optional: refresh table
      await fetchTableData(
        lastSearchPayload,
        pagination.page,
        pagination.limit,
      );
    } catch (error: any) {
      Swal.close();

      Swal.fire({
        icon: "error",
        title: "Failed",
        text: error?.message || "Unable to start Pre BGV. Please try again.",
        confirmButtonColor: "#f26522",
      });
    }
  };
  const loading = getTableData.loading;
  const getApiErrorMessage = (err: any, fallback = "Something went wrong.") =>
    err?.response?.data?.error ||
    err?.response?.data?.message ||
    err?.error ||
    err?.message ||
    fallback;

  return (
    <>
      {/* filters */}
      <FiltersTrackCase
        filterData={filterData}
        searchFilter={searchFilter}
        setFilterData={setFilterData}
        setSearchFilter={setSearchFilter}
        onSearch={handleSearch}
        storageKey="total_invite_sent"
      />

      {/* Table  */}

      {/* <div className="card mt-3 pt-2 pe-0">
        <div className="text-end">
          <button
            className="btn btn-sm btn-primary"
            onClick={handleDownloadExcel}
            disabled={loading}
          >
            <i className="bi bi-download pe-2"></i>
            Download Excel
          </button>
        </div>
        {loading ? (
          <Loading />
        ) : (
          <Datatable
            dataSource={filteredData}
            columns={columns}
            Selection={false}
            loading={getTableData.loading}
            rowKey="assignment_id"
            pagination={{
              current: pagination.page,
              pageSize: pagination.limit,
              total,
            }}
            handleTableChange={(pagination: any) => {
              handleTableChange(pagination.current, pagination.pageSize);
            }}
          />
        )}
      </div> */}
      <div className="card mt-3 pt-2 pe-0">
        <div className="d-flex justify-content-end align-items-center gap-2">
          {/* Selected count */}
          {selectedRows.length > 0 && (
            <span className="text-muted me-2">
              {selectedRows.length} candidate
              {selectedRows.length > 1 ? "s" : ""} selected
            </span>
          )}

          {/* Start Pre BGV */}
          {/* <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={handleStartPreBGV}
            disabled={
              loading ||
              bgvBulkVerification.loading ||
              selectedRows.length === 0
            }
          >
            {bgvBulkVerification.loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Starting...
              </>
            ) : (
              <>
                <i className="ti ti-player-play me-1"></i>
                Start Pre BGV
              </>
            )}
          </button> */}

          {/* Download Excel */}
          <div className="px-2">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={handleDownloadExcel}
              disabled={loading}
            >
              <i className="bi bi-download pe-2"></i>
              Export to Excel
            </button>
          </div>
        </div>

        {loading ? (
          <Loading />
        ) : (
          <Datatable
            dataSource={filteredData}
            columns={columns}
            Selection={false}
            loading={getTableData.loading}
            rowKey="assignment_id"
            fixedHeader
            tableHeight={650}
            pagination={{
              current: pagination.page,
              pageSize: pagination.limit,
              total,
            }}
            handleTableChange={(pagination: any) => {
              handleTableChange(pagination.current, pagination.pageSize);
            }}
          />
        )}
      </div>

      {/* Timeline */}
      {showTimeline && (
        <TimelineModal
          timelineData={timelineData}
          loading={timelineLoading}
          onClose={() => {
            setShowTimeline(false);
            setTimelineData([]);
          }}
        />
      )}
      {showModifyInvite && (
        <ModifyInviteModal
          handleClose={() => setShowModifyInvite(false)}
          applicant={selectedInvite}
          isSubmitting={resendInvitation.loading}
          handleSubmit={async (data: any) => {
            try {
              Swal.fire({
                title: "Processing...",
                text: "Please wait while we resend the invitation.",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: true,
                didOpen: () => {
                  Swal.showLoading();
                },
              });

              const payload = {
                case_id: Number(data.case_id ?? selectedInvite?.case_id),
                email_id: String(
                  data.email_id ?? data.email ?? selectedInvite?.email ?? "",
                ).trim(),
                phone_number: String(
                  data.phone_number ??
                    data.phone ??
                    selectedInvite?.phone ??
                    "",
                ).trim(),
              };

              const res = await resendInvitation.callApi(payload);

              const resData = res?.data;

              if (resData) {
                setItemList((prev) =>
                  prev.map((item) =>
                    String(item.case_id) === String(resData.case_id)
                      ? {
                          ...item,
                          email: payload.email_id,
                          phone: payload.phone_number,
                          invitation_date:
                            resData.invitation_sent_at ?? item.invitation_date,
                          days_elapsed: getDaysElapsed(
                            resData.invitation_sent_at,
                          ),
                          expires_at: getExpireIn(
                            resData.invitation_expires_at,
                          ),
                        }
                      : item,
                  ),
                );
              }

              setShowModifyInvite(false);
              await fetchTableData(
                lastSearchPayload,
                pagination.page,
                pagination.limit,
              );
              Swal.close();
              await Swal.fire({
                icon: "success",
                title: "Invite Sent Successfully",
                text: resData?.email_sent
                  ? "Invitation has been sent successfully."
                  : "Invite resent, but email delivery could not be confirmed.",
                confirmButtonColor: "#f26522",
                confirmButtonText: "OK",
              });
            } catch (error: any) {
              Swal.close();
              Swal.fire({
                icon: "error",
                title: "Failed",
                text: getApiErrorMessage(error),
                confirmButtonColor: "#f26522",
              });
            }
          }}
        />
      )}
    </>
  );
};

export default TotalInviteSent;
